import { type ReactNode } from 'react';
import s from './line.module.scss';

export function Line(): ReactNode {
    return <div className={s.line} />;
}
